<template>
<b-container fluid class="container">
   <b-row class="justify-content-md-center">
          <b-col col md="3" class="text-center">
           <Descripcion/>
            <div class="mb-5" >
                  <img src="../assets/wizard7.png" class="img-fluid" alt="" />
            </div>
            <hr>
            <div class="mb-5">
              <h6>Estamos para ayudarte</h6>
              <p style="font-size: 15px">¿Deseas ser asistido por uno de nuestros asesores?</p>
                  <b-button @click.prevent="" variant="outline-primary" class="button_H11">ESTAMOS PARA AYUDARTE</b-button>
            </div>
          </b-col>
          <b-col  col md="9" class="card-body text-center">
            <Sesion/>
            <h1 class="mt-5">Realiza un pago de <span style="color: #B3DB5A">${{this.monto}}</span> para apartarlo</h1>
            <h5 style="font-weight: bold;" class="mt-3">Apartado 100% reembolsable.</h5>

        <div class="col-lg-12">
        <b-row align-h="center" class="p-3 mb-5 bg-body rounded shadow">
            <b-col lg="4" style="" class="text-left p-3 rounded card-information">
              <b-row cols="1">
                <b-col>
                    <b-img src="../assets/Verificado2.png" style="width: 50px; height:auto;" alt=""></b-img> 
                    <span class="h2R"> Pago Exitoso.</span>
                </b-col>
                <b-col><h2 class="h2V text-left mt-5">Venta por Internet</h2></b-col>
                <b-col><p style="font-size: 14px; color: grey;">Monto:</p><h1 class="h1V">${{this.monto}} mxn</h1></b-col>
                <b-col>
                  <b-row cols="2">
                    <b-col cols="5"><h4 class="h4R">ID cliente:</h4></b-col>
                    <b-col ><p style="font-size: 14px; color: grey;">{{this.iduser}}</p></b-col>
                  </b-row>
                  <b-row cols="1">
                    <b-col cols="5"><h4 class="h4R">Cliente: </h4></b-col>
                    <b-col><p style="font-size: 14px; color: grey;"> {{this.nombre}}</p></b-col>
                    <b-col cols="5"><h4 class="h4R">Fecha: </h4></b-col>
                    <b-col><p style="font-size: 14px; color: grey;"> {{this.fecha}}</p></b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-col>

            <b-col class="text-left bg-body rounded" >
                <b-col><h4 style="font-size: 12px;" class="mt-1 h4R">Este pago es reembolsable y recuerda que si el estatus de Reservado dejará de estar disponible en 5 días.</h4></b-col>
                <b-col><p style="font-size: 12px; color: grey;">El presente pagaré es negociable únicamente con instituciones bancarias, a excepción que este sea suscrito por tarjetahabiente de American Express.</p>
                <p style="font-size: 12px; color: grey;">Por este pagaré me obligo incondicionalmente a pagar a la orden del banco acreditante el importe de este título, este
                    pagare procede del contrato de apertura de crédito que el banco acreditante y el tarjetahabiente tienen.</p>
                <p style="font-size: 12px; color: grey;">Reconozco y acepto que el presente es comprobante de la  operación señalada. El cual tiene el mero valor probatorio
                    y fuerza legal en virtud de que firme y/o digite mi firma electrónica, la cual es de mi exclusiva responsabilidad por lo que manifiesto plena conformidad respecto al cargo efectuando a la cuenta de la que deriva esta tarjeta.</p>
                <p style="font-size: 12px; color: grey;">Nota: Incluir copia digital de identificación oficial con firmaasí como la tarjeta objeto del cargo por ambas caras.</p></b-col>
                  <div class="mt-3"><b-button @click.prevent="confirmar()" class="button_H mt-5">CONFIRMAR</b-button></div>
            </b-col>
        </b-row>
            <!-- <b-overlay :show="busy" variant="light" opacity="0.90" no-wrap >
              <template #overlay>
                <div v-if="processing"  style="background-color: #CB0035" class="text-center text-light p-4 rounded">
                  <b-icon icon="credit-card2-front" font-scale="4"></b-icon>
                  <div class="mb-3"><h3> Pagando </h3></div>
                  <b-progress min="1" max="20" :value="counter" variant="danger" height="3px" class="mx-n4 rounded-0"></b-progress>
                </div>
                  
                <div v-else tabindex="-1" aria-modal="false" aria-labelledby="form-confirm-label" class="text-center p-3">
                  <h2 class="h2Confi"><strong id="form-confirm-label">Confirmar pago</strong></h2>
                  <div class="text-center">
                    <b-button variant="success" class="mr-3 button_confi" @click.prevent="pagar()">PAGAR</b-button>
                    <b-button variant="secondary" class="mr-3 button_confi2" @click="onCancel">NO PAGAR</b-button>
                  </div>
                </div>
              </template>
            </b-overlay> -->
        </div>

          </b-col>
    </b-row>
</b-container>
</template>

<script>
import Sesion from './Sesion.vue';
import Descripcion from './Descripcion.vue';

export default {
  name: 'Ticket',

  components: {
    Sesion,
    Descripcion
  },

    data() {
    return {
      monto: sessionStorage.getItem("montoWeb"),
      nombre: sessionStorage.getItem("nombre")+' '+sessionStorage.getItem("paterno")+' '+sessionStorage.getItem("materno"),
      iduser: sessionStorage.getItem("loginAct"),
      fecha: '',
      hora: '',
        show: true,
      };
  },

  methods: {
        onSubmit(event) {
            event.preventDefault();
        },

        onReset(event) {
            window.history.go(-2);
        },

        confirmar(){
          this.$router.push({ path: '/Bienvenida'});
        },
        
        regresar(){
            window.history.go(-1);
        },

        refresh(){
          location.reload();
        },

        tiempo(){
          const date = new Date();
          const output = date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
          this.fecha = output;
          }

  },
  
  created() {
    this.tiempo();
  },

}
</script>

<style scoped>


</style>